import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CookieProvider, useCookies } from './context/CookieContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import MapPage from './pages/MapPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CullForm from './pages/CullForm';
import CullCard from './pages/CullCard';
import DataTable from './pages/DataTable';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import CookieConsent from './components/CookieConsent';
import './App.css';

const AppContent: React.FC = () => {
  const { acceptCookies, declineCookies } = useCookies();

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="map" element={<MapPage />} />
            <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="add-cull" element={<ProtectedRoute><CullForm /></ProtectedRoute>} />
            <Route path="edit-cull/:id" element={<ProtectedRoute><CullForm /></ProtectedRoute>} />
            <Route path="view-cull/:id" element={<ProtectedRoute><CullCard /></ProtectedRoute>} />
            <Route path="data" element={<ProtectedRoute><DataTable /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieConsent onAccept={acceptCookies} onDecline={declineCookies} />
      </div>
    </Router>
  );
};

function App() {
  return (
    <CookieProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </CookieProvider>
  );
}

export default App;
